import {ClayPanel} from "../component/basic/ClayPanel";
import React from "react";
import {Header} from "../component/context/Header";
import {ClayButton} from "../component/basic/ClayButton";
import {ClayAlert} from "../component/basic/ClayAlert";
import {Icon} from "@iconify/react";

export function PageIndex() {
    return <>
        <Header />
        {/*<ClayAlert className={"content-limit mb-4"}>*/}
        {/*    当前网站正在测试运行中*/}
        {/*</ClayAlert>*/}
        <div className={"content-limit"}>
            <ClayPanel backgroundImage={"/images/2022/town/modern.jpg"}>
                <div className={"flex items-center text-5xl justify-center h-[50vh] max-h-96 clay-heavy-text-shadow"}>
                    2024 新征程 🎉
                    {/*<ClayButton className={"text-sm"} color={"bg-clay-green"}>*/}
                    {/*    测试*/}
                    {/*</ClayButton>*/}
                </div>
            </ClayPanel>
        </div>
        <div className={"content-limit mt-8 flex items-center"}>
            <div>
                <div className={"text-xl"}>
                    设计
                </div>
                <div className={"text-sub text-sm mb-4"}>
                    粘土团队设计集
                </div>
            </div>
            <div className={"ml-auto text-sub"}>
                暂未开放
            </div>
        </div>

        <div className={"content-limit grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4"}>
            <GameStatusCard name={"粘粘小镇"} image={"/images/launcher/town.png"} />
            <GameStatusCard name={"陨落"} image={"/images/launcher/fallen.jpg"} />
            <GameStatusCard name={"Clay粘土"} image={"/images/launcher/clay.jpg"} />
            <GameStatusCard name={"起床战争"} image={"/images/launcher/matchpoint.jpg"} />
            <GameStatusCard name={"粘土跑酷王"} image={"/images/launcher/parkour.jpg"} />
            <GameStatusCard name={"粘土骑士团"} image={"/images/launcher/knight.jpg"} />
        </div>

        <div className={"content-limit mt-8 flex items-center"}>
            <div>
                <div className={"text-xl"}>
                    技术
                </div>
                <div className={"text-sub text-sm mb-4"}>
                    粘土开发团队开发的软件、开源项目
                </div>
            </div>
            <div className={"ml-auto text-sub"}>
                部分开放
            </div>
        </div>

        <div className={"content-limit grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"}>
            <ProjectCard name={"Pangu"} stack={"Java"} source={"https://github.com/trychen/Pangu"} desc={"盘古是一款开源的框架 Mod，由Clay提供更新支持。提供了通信、UI、渲染等功能。可以用于服务端 Mod 开发和内容 Mod 开发。使用时请遵守开源协议。"}/>
            <ProjectCard name={"CMPD™2.0"} stack={"Kotlin/Multiplatform"} desc={"Clay Modern Pixel Design。粘土云开发的一款通用UI框架，支持在游戏、Web、移动端、桌面端中使用，基于 Compose 技术。包含使用设计语言 Clay Modern Pixel Design 开发的第一方组件库 Clay UI Components 2.0。"}/>
            <ProjectCard name={"粘土云计算平台"} stack={"Go, C++, Kotlin, Jvav"} desc={"这是一个基于云计算技术，以粘土云为核心的PaaS平台。它提供了强大的计算能力和存储服务，为开发者提供了一个稳定、高效、可扩展的运行环境。"}/>
            <ProjectCard name={"Jvav Compiler"} stack={"Go"} desc={"Jvav是一门轻量化的脚本语言，用于Clay开发团队DSL设计，支持在 JVM、JS、LLVM 中使用。Jvav的语法结构类似于Java，因此Java开发者能够很快地上手使用Jvav进行编程。Jvav支持面向对象编程，同时还提供了诸如变量声明、条件控制语句、循环语句、函数等常见的编程语言特性。用作自定义 UI 的搭建等场景。"}/>
            <ProjectCard name={"粘土云主数据"} stack={"Kotlin, Jvav"} desc={"数据管理系统，用于维护组织内部重要的核心数据，为不同模块之间提供数据转换和同步功能。"}/>
            <ProjectCard name={"Endpoint Node"} stack={"Java, Kotlin"} desc={"支持粘土云架构的游戏服务端核心扩展，支持协程、分布式、字节码注入等功能。"}/>
            <ProjectCard name={"Clay Platform"} stack={"Rust"} desc={"粘土云架构后端引擎。它提供了完整的分部署游戏后端架构解决方案，包括服务管理、数据库、存储、缓存、监控、安全等功能。"}/>
            <ProjectCard name={"Clay Matrix"} stack={"Jvav"} desc={"粘土自主研发的一个社交插件，包含好友、聊天等除了反作弊的功能。"}/>
            <ProjectCard name={"Clay DB"} stack={"C++"} desc={"一款基于粘土云架构的NoSQL分布式数据库系统，具有高可用性、高性能和高灵活性等特点。它可以在多个节点之间实现数据的自动同步和负载均衡，支持大文档存储。可以存储游戏地图、玩家背包数据等复杂数据结构。"}/>
            <ProjectCard name={"CPD™1.0"} stack={"Java"} source={"https://github.com/trychen/Pangu"} desc={"Clay Pixel Design。粘土云基于Pangu开发的UI框架，支持在 LWJGL 中使用，基于 OpenGL 技术。包含使用设计语言 Clay Pixel Design 开发的第一方组件库 Clay UI Components 1.0。"}/>
        </div>
    </>
}

function GameStatusCard({ image, name }: { image: string; name: string; }) {
    return <ClayPanel border={false} backgroundColor={"bg-background hover:bg-background/30"}>
        <ClayPanel backgroundImage={image}>
            <div className={"w-full"} style={{ aspectRatio: "400/225"}}> </div>
        </ClayPanel>
        <div className={"py-2 px-4"}>
            <div>{name}</div>
            <div className={"text-sub text-xs"}>浏览人数 N/A</div>
        </div>
    </ClayPanel>
}
function ProjectCard({ name, desc, stack, source, website }: { name: string; desc: string; stack: string; source?: string; website?: string; }) {
    return <ClayPanel backgroundColor={"bg-background"} className={"h-full"}>
        <div className={"p-6"}>
            <div className={"text-xl"}>{name}</div>
            <div className={"text-sub text-xs mt-1"}>{stack}</div>
            <div className={"mt-2 text-xs"}>
                {desc}
            </div>
            {source && <div className={"flex mt-6"}>
                <a href={source} target={"_blank"} rel="noreferrer">
                    <ClayButton className={"text-sm"} color={"bg-clay-blue-gray"}><Icon icon={"pixelarticons:git-branch"} className={"mr-2"} /> 源码</ClayButton>
                </a>
            </div>}
            {website && <div className={"flex mt-6"}>
                <a href={website} target={"_blank"} rel="noreferrer">
                    <ClayButton className={"text-sm"} color={"bg-clay-blue-gray"}><Icon icon={"pixelarticons:external-link"} className={"mr-2"} /> 进入</ClayButton>
                </a>
            </div>}
        </div>
    </ClayPanel>
}
